import { styled } from 'styled-components'

export const Container = styled.div`
  padding: 24px 20px 16px;
  border-top: 1px solid ${({ theme }) => theme.colors.grayMedium};
`

export const ItemList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`
